import { useEffect, useState } from "react";
import { Alert, Button, TextField } from "@mui/material";
import { Link } from "react-router-dom";
import Modal from "../../../../shared/ui/common/Modal";
import ImageGallery from "../../../../shared/ui/imageGallery";
import { promotionAmount } from "../../lib/promotion-amount";

export default function ReservationDialog({ row, close, catalogue }) {
  const [operationId, setOperationId] = useState(""), [amount, setAmount] = useState(""), [confirmation, setConfirmation] = useState("");
  const [description, setDescription] = useState(""), [error, setError] = useState(""), [notice, setNotice] = useState("");
  useEffect(() => {
    if (!row) return;
    setOperationId(crypto.randomUUID()); setAmount(((row.amountMinor - (row.refundedAmountMinor || 0)) / 100).toFixed(2));
    setConfirmation(""); setDescription(""); setError(""); setNotice("");
  }, [row]);
  async function stop() {
    setError("");
    try { if (await catalogue.mutate(row)) close(); } catch (reason) { setError(reason.message); }
  }
  async function refund() {
    setError("");
    if (!/^\d{1,7}(\.\d{1,2})?$/.test(amount)) { setError("مبلغ یورویی معتبر وارد کنید."); return; }
    const amountMinor = Math.round(Number(amount) * 100);
    if (amountMinor < 1 || amountMinor > row.amountMinor - (row.refundedAmountMinor || 0) || !description.trim()) {
      setError("مبلغ مثبت، در محدوده مانده قابل بازپرداخت و توضیح ضروری است."); return;
    }
    try {
      if (await catalogue.mutate(row, { id: operationId, amountMinor, description: description.trim() }))
        setNotice("درخواست بازپرداخت ثبت شد؛ نتیجه نهایی فقط پس از تأیید درگاه در گزارش پرداخت مشخص می‌شود.");
    } catch (reason) { setError(reason.message); }
  }
  return <Modal open={Boolean(row)} close={() => { if (!catalogue.saving) close(); }} title="جزئیات سفارش تبلیغات">
    {row && <div className="flex flex-col gap-4 p-2">
      <p>مالک: <Link to={`/users/${row.customerUserId}`}>کاربر {row.customerUserId}</Link></p>
      <p>غرفه: {row.boothId} — آگهی: {row.advertisementId}</p>
      <p>{row.planName} — {promotionAmount(row.amountMinor, row.currency)}</p>
      <p>از {new Date(row.startsAt).toLocaleString("fa-IR")} تا {new Date(row.endsAt).toLocaleString("fa-IR")}</p>
      {row.bookedStartsAt && Date.parse(row.bookedStartsAt) !== Date.parse(row.startsAt) &&
        <Alert severity="info">بازه به‌دلیل تأیید دیرهنگام پرداخت جابه‌جا شده است؛ شروع اولیه: {new Date(row.bookedStartsAt).toLocaleString("fa-IR")}</Alert>}
      {row.stopReason && <Alert severity="warning">علت توقف: {({ operator: "تصمیم ادمین", capacity_conflict: "نبود ظرفیت برای بازه جایگزین پس از پرداخت دیرهنگام",
        ad_unavailable: "آگهی حذف یا از تأیید خارج شده", ownership_changed: "تغییر مالکیت", verification_failed: "نیاز به بررسی تطبیق پرداخت", payment_reversed: "برگشت پرداخت" })[row.stopReason] || "نیاز به بررسی ادمین"}</Alert>}
      <p className="break-all">شناسه پرداخت: {row.paymentOrderId || "پرداخت آغاز نشده است"}</p>
      {row.paymentOrderId && <Link to={`/transaction?search=${encodeURIComponent(row.paymentOrderId)}`}>گزارش پرداخت</Link>}
      {row.placements.map((item) => <div key={item.code} className="flex flex-col gap-2">
        <p>{item.code}</p><div className="grid grid-cols-2 gap-3">
          {item.desktopFileId && <div><p>دسکتاپ</p><ImageGallery item={item.desktopFileId} /></div>}
          {item.mobileFileId && <div><p>موبایل</p><ImageGallery item={item.mobileFileId} /></div>}
        </div>
      </div>)}
      {!row.stopped && <Button color="error" variant="outlined" disabled={catalogue.saving} onClick={stop}>توقف نمایش تبلیغ</Button>}
      {row.paymentOrderId && row.gatewayCode !== "zarinpal" && !notice && <div className="flex flex-col gap-3">
        <TextField label="مبلغ بازپرداخت (یورو)" value={amount} disabled={catalogue.saving} onChange={(event) => setAmount(event.target.value)} inputProps={{ inputMode: "decimal", dir: "ltr" }} />
        <TextField label="دلیل بازپرداخت" value={description} disabled={catalogue.saving} onChange={(event) => setDescription(event.target.value)} inputProps={{ maxLength: 200 }} />
        <TextField label="برای تأیید بنویسید: بازپرداخت" value={confirmation} disabled={catalogue.saving} onChange={(event) => setConfirmation(event.target.value)} />
        <Button color="error" variant="contained" disabled={catalogue.saving || confirmation.trim() !== "بازپرداخت"} onClick={refund}>درخواست بازپرداخت و توقف نمایش</Button>
      </div>}
      {error && <Alert severity="error">{error}</Alert>}{notice && <Alert severity="info">{notice}</Alert>}
    </div>}
  </Modal>;
}
